<template>
	<div class="container card w-auto">
		<div class="card-header p-3 py-5">
			<p class="name">{{ $t('Update Address') }}</p>
			<i class="icon bi bi-x" @click="close"></i>
		</div>

		<div class="card-body p-3">
			<div class="d-flex flex-1 gap-3 pt-3" v-if="profileStore.loadingPage">
				<div class="w-100">
					<div class="skeleton mb-4" style="height: 35px; width: 100%"></div>
					<div class="skeleton mb-4" style="height: 35px; width: 100%"></div>
					<div class="skeleton mb-4" style="height: 35px; width: 100%"></div>
					<div class="skeleton mb-4" style="height: 35px; width: 100%"></div>
					<div class="skeleton mb-4" style="height: 35px; width: 100%"></div>
					<div class="skeleton mb-4" style="height: 35px; width: 100%"></div>
				</div>
			</div>
			<AppForm @submit="onSubmit" ref="form" v-else>
				<div class="d-flex flex-column">
					<AppInput
						:label="$t('profile.name')"
						v-model="profileStore.form.customer_address.receiver_name"
						:rules="['required']"
					/>

					<AppInput
						:label="$t('profile.mobile-number')"
						v-model="profileStore.form.customer_address.phone"
						:rules="['required']"
						class="phone-input"
					>
						<template #start-icon>
							<InlineSvg :src="loadFile('saudi-flag.svg')" />
							<span class="num-text">+966</span>
						</template>
					</AppInput>

					<AppInput
						:label="$t('profile.email')"
						v-model="profileStore.form.email"
						:rules="['isEmail']"
					/>

					<AppSelect
						:label="$t('profile.city')"
						v-model="profileStore.form.customer_address.city"
						:fetchDataFunction="SharedService.getCities"
						:rules="['required']"
						returnObject
						optionLabel="name"
						optionValue="id"
					/>

					<AppInput
						:label="$t('profile.district')"
						v-model="profileStore.form.customer_address.district"
						:rules="['required']"
					/>

					<AppInput
						:label="$t('profile.street-name')"
						v-model="profileStore.form.customer_address.street_name"
						:rules="['required']"
					/>

					<AppInput
						:label="$t('profile.building-number')"
						v-model="profileStore.form.customer_address.building_number"
						:rules="['required']"
					/>

					<div class="d-flex gap-3 mb-5">
						<AppRadio
							v-model="profileStore.form.customer_address.address_type"
							value="COMPANY"
							:label="$t('profile.company')"
						/>
						<AppRadio
							v-model="profileStore.form.customer_address.address_type"
							value="HOME"
							:label="$t('profile.home')"
						/>
					</div>

					<AppButton
						:label="$t('profile.update-address')"
						type="button"
						size="lg"
						:loading="profileStore.loading"
						@click="$refs.form.submit()"
					/>
				</div>
			</AppForm>
		</div>
		<div></div>
	</div>
</template>

<script setup>
import InlineSvg from '@/v2/components/inline-svg';

import { ref, onMounted } from 'vue';
import { useProfileStore } from '@/components/whatsapp-managment/stores/profile';
import { loadFile } from '@/components/utils.js';
import SharedService from '@/v2/services/shared';

const emit = defineEmits(['hideEditProfile']);

const props = defineProps({
	data: {
		type: Object,
		default: {},
	},
});

const profileStore = useProfileStore();

onMounted(async () => {
	profileStore.getProfile(props.data?.id);
});

const close = () => {
	emit('hideEditProfile');
};

const onSubmit = async () => {
	if (!props.data?.id) {
		const externalId = props.data?.conversation?.whatsapp_id;
		const data = await profileStore.createProfile(externalId);
		const base_url = window.location.origin;
		document.location.href = `${base_url}/orders/create?customer_id=${data?.id}`;
	} else {
		const success = await profileStore.updateProfile(props.data?.id);
		if (success) {
			close();
		}
	}
};
</script>

<style scoped lang="scss">
@import './styles/index.scss';
.card-header {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #efefef !important;
	margin-bottom: 7px;
	.name {
		font-size: 18px;
		color: #101828;
		font-weight: 600;
		margin-bottom: 0;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 80%;
	}
	.icon {
		&:before {
			color: #98a2b3;
			font-size: 24px;
		}
	}
}
.skeleton {
	background-color: #e0e0e0;
	border-radius: 4px;
	animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
	0% {
		background-color: #e0e0e0;
	}

	50% {
		background-color: #c2c2c2;
	}

	100% {
		background-color: #e0e0e0;
	}
}

.phone-input {
	::v-deep(.input-wrapper) {
		direction: ltr;
	}
	.num-text {
		font-size: 0.875rem;
	}
}
</style>
